module.exports = __webpack_public_path__ + "img/agent2.f14abcdd.png";